import React from 'react';
import './PersonCard.css';

/**
 * Displays a person: headshot on the left, name/role/bio on the right.
 * Falls back to an initial placeholder if no image is provided or the image fails to load.
 */
function PersonCard({ name, role, image, bio }) {
  const [imgError, setImgError] = React.useState(false);
  const initial = name ? name.trim().charAt(0).toUpperCase() : '?';

  return (
    <article className="person-card">
      <div className="person-photo">
        {image && !imgError ? (
          <img
            src={image}
            alt={name}
            onError={() => setImgError(true)}
            loading="lazy"
          />
        ) : (
          <div className="person-photo-placeholder" aria-hidden="true">
            {initial}
          </div>
        )}
      </div>
      <div className="person-content">
        <h3 className="person-name">{name}</h3>
        {role && <p className="person-role">{role}</p>}
        {bio && (
          <div className="person-bio">
            {bio.split('\n\n').map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default PersonCard;
